import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {FormGroupComponent} from "../../form-inputs/form-group/form-group.component";
import {
  MultiSelectWithStaticOptionsStaticComponent
} from "../../form-inputs/multi-select-static-with-static-options/multi-select-with-static-options-static.component";
import {IntFilterComponent} from "../../table-filter/int-filter/int-filter.component";
import {DateFilterComponent} from "../../table-filter/date-filter/date-filter.component";
import {AuthenticatedBaseComponent} from '../../../authenticated/authenticated-base.component';
import {ContentHeaderService} from '../../../services/content-header.service';
import {TitleService} from '../../../services/title.service';
import {JsonPipe, NgIf} from '@angular/common';
import {environment} from '../../../../environments/environment';
import {MultiSelectEnumComponent} from '../../form-inputs/multi-select-enum/multi-select-enum.component';
import {
  MultiSelectWithServiceIdArrayComponent
} from '../../form-inputs/multi-select-with-service-id-array/multi-select-with-service-id-array.component';
import {EmailService} from '../../../services/api/administration/email.service';
import {DiagnosisService} from '../../../services/api/diagnosis.service';
import {AddableBackofficeUserService} from '../../../services/api/patients/addable-backoffice-user.service';
import {AddableDoctorService} from '../../../services/api/patients/addable-doctor.service';
import {UserService} from '../../../services/api/administration/user.service';
import {
  MultiSelectWithServiceComponent
} from '../../form-inputs/multi-select-with-service/multi-select-with-service.component';
import {AddableTeamLeadersService} from '../../../services/api/time-tracking/addable-team-leaders.service';
import {ProcessService} from '../../../services/api/quality-management/process.service';
import {TimeTrackingEmployeeService} from '../../../services/api/time-tracking/time-tracking-employee.service';
import {Backend} from '@generated-backend-types';
import TableConfigColumn = Backend.App.Resources.Dashboard.Meta.TableConfigColumn;
import TableConfig = Backend.App.Resources.Dashboard.Meta.TableConfig;
import ModelStateEnum = Backend.App.Enums.ModelStateEnum;
import PatientLanguageEnum = Backend.App.Enums.PatientLanguageEnum;
import PatientStateEnum = Backend.App.Enums.PatientStateEnum;
import EmailTypeEnum = Backend.App.Enums.Administration.EmailTypeEnum;
import PatientOriginEnum = Backend.App.Enums.PatientOriginEnum;
import PatientGenderEnum = Backend.App.Enums.PatientGenderEnum;
import InquiryStateEnum = Backend.App.Enums.InquiryStateEnum;
import ProcessCategoryEnum = Backend.App.Enums.QualityManagement.ProcessCategoryEnum;
import ProcessRoleEnum = Backend.App.Enums.QualityManagement.ProcessRoleEnum;
import ProcessPriorityEnum = Backend.App.Enums.QualityManagement.ProcessPriorityEnum;
import ProcessComplexityEnum = Backend.App.Enums.QualityManagement.ProcessComplexityEnum;
import {PatientService} from '../../../services/api/patients/patient.service';
import TimeTrackingAbsenceRequestStateEnum = Backend.App.Enums.TimeTracking.TimeTrackingAbsenceRequestStateEnum;
import TimeTrackingEntryTypeEnum = Backend.App.Enums.TimeTracking.TimeTrackingEntryTypeEnum;
import PatientSourceEnum = Backend.App.Enums.PatientSourceEnum;
import TableConfigColumnTypeEnum = Backend.App.Enums.TableConfigColumnTypeEnum;
import GermanStateEnum = Backend.App.Enums.TimeTracking.GermanStateEnum;

@Component({
  selector: 'app-table-filter-input[inputFormControl][column][tableConfig]',
  templateUrl: './table-filter-input.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormGroupComponent,
    MultiSelectWithStaticOptionsStaticComponent,
    IntFilterComponent,
    DateFilterComponent,
    IntFilterComponent,
    DateFilterComponent,
    NgIf,
    TranslatePipe,
    JsonPipe,
    MultiSelectEnumComponent,
    MultiSelectWithServiceIdArrayComponent,
    MultiSelectWithServiceComponent,
  ],
  standalone: true
})
export class TableFilterInputComponent extends AuthenticatedBaseComponent {

  public readonly TableConfigColumnTypeEnum = TableConfigColumnTypeEnum;

  @Input() column!: TableConfigColumn;
  @Input() inputFormControl!: FormControl;
  @Input() tableConfig?: TableConfig;
  @Input() small: boolean = false;
  protected readonly Validators = Validators;
  protected readonly environment = environment;
  protected readonly ModelStateEnum = ModelStateEnum;
  protected readonly PatientLanguageEnum = PatientLanguageEnum;
  protected readonly PatientStateEnum = PatientStateEnum;
  protected readonly EmailTypeEnum = EmailTypeEnum;
  protected readonly PatientOriginEnum = PatientOriginEnum;
  protected readonly PatientGenderEnum = PatientGenderEnum;
  protected readonly InquiryStateEnum = InquiryStateEnum;
  protected readonly ProcessCategoryEnum = ProcessCategoryEnum;
  protected readonly ProcessRoleEnum = ProcessRoleEnum;
  protected readonly ProcessPriorityEnum = ProcessPriorityEnum;
  protected readonly ProcessComplexityEnum = ProcessComplexityEnum;
  protected readonly TimeTrackingAbsenceRequestStateEnum = TimeTrackingAbsenceRequestStateEnum;
  protected readonly TimeTrackingEntryTypeEnum = TimeTrackingEntryTypeEnum;
  protected readonly PatientSourceEnum = PatientSourceEnum;
  protected readonly GermanStateEnum = GermanStateEnum;

  public constructor(
    protected override cdr: ChangeDetectorRef,
    protected override translate: TranslateService,
    protected override contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    protected readonly diagnosisService: DiagnosisService,
    public readonly emailService: EmailService,
    protected readonly userService: UserService,
    protected readonly addableDoctorService: AddableDoctorService,
    protected readonly addableBackofficeUserService: AddableBackofficeUserService,
    protected readonly patientService: PatientService,
    protected readonly addableTeamLeadersService: AddableTeamLeadersService,
    protected readonly processService: ProcessService,
    protected readonly timeTrackingEmployeeService: TimeTrackingEmployeeService,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }
}
